export default "__VITE_ASSET__Ddag66pm__"